const MAP_ACTION_TYPE = '[Map]';

export class SetMapIsLoading {
  public static type = `${MAP_ACTION_TYPE} SetMapIsLoading`;

  public constructor(public readonly isLoading?: boolean) {}
}

export class SetActiveDataTypes {
  public static type = `${MAP_ACTION_TYPE} SetActiveDataTypes`;

  public constructor(public readonly dataTypes: number[]) {}
}

export class SetActiveNetTypes {
  public static type = `${MAP_ACTION_TYPE} SetActiveNetTypes`;

  public constructor(public readonly types: number[]) {}
}
